import { defineMessages } from 'react-intl';

export default defineMessages({
    printConfirmation: {
        id: 'rewrite.common.views.ml-confirmation.Print Confirmation',
        defaultMessage: 'Print Confirmation'
    },
    goToAccount: {
        id: 'rewrite.common.views.ml-confirmation.Go To Account',
        defaultMessage: 'Go To Account'
    },
    rewrite: {
        id: 'rewrite.common.views.ml-confirmation.Rewrite',
        defaultMessage: 'Rewrite'
    },
    refundDue: {
        id: 'rewrite.common.views.ml-confirmation.Refund Due',
        defaultMessage: 'Refund Due'
    },
    amountDue: {
        id: 'rewrite.common.views.ml-confirmation.Amount Due',
        defaultMessage: 'Amount Due'
    },
    policyChangeScriptUppercase: {
        id: 'rewrite.common.views.ml-confirmation.POLICY CHANGE SCRIPT',
        defaultMessage: 'POLICY CHANGE SCRIPT'
    },
    requierdDocumentContentText: {
        id: 'rewrite.common.views.ml-confirmation.You must submit supporting documentation for the following:',
        defaultMessage: 'You must submit supporting documentation for the following:'
    },
    typePolicy: {
        id: 'rewrite.common.views.ml-confirmation.Type Policy',
        defaultMessage: '{policyType} Policy'
    },
    coverageDocumentUppercase: {
        id: 'rewrite.common.views.ml-confirmation.COVERAGE DOCUMENT',
        defaultMessage: 'COVERAGE DOCUMENT'
    },
    actionUppercase: {
        id: 'rewrite.common.views.ml-confirmation.ACTION',
        defaultMessage: 'ACTION'
    },
    yourPolicyDocuments: {
        id: 'rewrite.common.views.ml-confirmation.Your Policy Documents',
        defaultMessage: 'Your Policy Documents'
    },
    view: {
        id: 'rewrite.common.views.ml-confirmation.View',
        defaultMessage: 'View'
    },
    yourIDCards: {
        id: 'rewrite.common.views.ml-confirmation.Your ID Cards',
        defaultMessage: 'Your ID Cards'
    },
    congratulations: {
        id: 'rewrite.common.views.ml-confirmation.Congratulations! This policy has been successfully rewritten',
        defaultMessage: 'Congratulations! This policy has been successfully rewritten.'
    },
    congratulationsWV: {
        id: 'rewrite.common.views.ml-confirmation.A one-time payment, equal to the first installment amount, must be submitted immediately.',
        defaultMessage: 'A one-time payment, equal to the first installment amount, must be submitted immediately.'
    },
});